import { NgModule } from '@angular/core';
import { NormaliseString } from './text-transform.pipe';
import { MapDeepObjectChangeDiff, MapDeepObjects } from './deep-object.pipe';

@NgModule({
  declarations: [NormaliseString, MapDeepObjects, MapDeepObjectChangeDiff],
  exports: [NormaliseString, MapDeepObjects, MapDeepObjectChangeDiff],
})
export class PipesModule {}
